import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";
import { createSearchParameters } from "@/helpers/SearchHelper.js";

export {
    GetFeedEntries,
    UpdateFeedEntry,
    CreateNewEntry,
    GetSingleFeedEntry,
    DeleteFeedEntry,
    SearchFeedEntries,
    GetPublicationFeedEntry

};

function GetFeedEntries(onSuccess, onError ) {
    
    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + '/feedentries', headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function UpdateFeedEntry(feedEntryId, updatedFeedEntry, onSuccess, onError) {
    
    var headers = getAuthHeader();

    axios
        .put(process.env.VUE_APP_BASE_API_URL + '/feedentries?feedEntryId=' + feedEntryId, updatedFeedEntry, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function CreateNewEntry(newFeedEntry, onSuccess, onError) {
    var headers = getAuthHeader();

    axios
        .post(process.env.VUE_APP_BASE_API_URL + '/feedentries', newFeedEntry, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function GetSingleFeedEntry(feedEntryId, onSuccess, onError) {
    
    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + '/feedentries/' + feedEntryId, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function GetPublicationFeedEntry(publicationId, onSuccess, onError) {
    
    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + '/publicationfeedentries/' + publicationId, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteFeedEntry(feedEntryId, onSuccess, onError) {
    
    var headers = getAuthHeader();

    axios
        .delete(process.env.VUE_APP_BASE_API_URL + '/feedentries/' + feedEntryId, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function SearchFeedEntries(requestData, onSuccess, onError) {

    var parameters = createSearchParameters(requestData);
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/feedentrysearch?" + parameters, headers)
        .then(response => {

            if (response.data && response.data.httpResultCode == 500) {
                onError(response);
            } else {
                onSuccess(response.data);
            }
        })
        .catch(error => {
            onError(error);
        });
}
